import { Divider, Stack, Typography } from "@mui/material";
import { Story } from ".";
import COLORS from "../../styles/colors";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";

const messages = {
  readMore: "Read More",
};

const StoryCard = ({ description, id, image, title, path }: Story) => {

  const navigate = useNavigate();

  const onReadMoreClick = () => {
    navigate(path);
  };

  return (
    <>
      <Stack height="100%" justifyContent="space-between">
        <Stack>
          <img src={image} alt="blogs" width="100%" height={"100%"} />

          <Typography
            mt={4}
            fontSize={22}
            fontWeight={700}
            color={COLORS.DARK_BLUE}
          >
            {title}
          </Typography>

          <Typography
            mt={2}
            fontSize={16}
            fontWeight={400}
            color={COLORS.GREY_TEXT}
            textAlign="justify"
          >
            {description}
          </Typography>
        </Stack>

        <Stack spacing={1} mt={4}>
          <Stack
            direction="row"
            spacing={0.5}
            alignItems="center"
            onClick={onReadMoreClick}
          >
            <Typography
              fontSize={16}
              fontWeight={700}
              color={COLORS.DARK_BLUE}
              sx={{ cursor: "pointer" }}
            >
              {messages.readMore}
            </Typography>

            <EastIcon fontSize="small" sx={{ color: COLORS.DARK_BLUE }} />
          </Stack>
        </Stack>
      </Stack>

      <Divider
        sx={{
          mt: 1,
          border: 0,
          borderTop: `2px dashed ${COLORS.DARK_BLUE}`,
        }}
      />
    </>
  );
};

export default StoryCard;
